<template>
  <div class="order-content">
    <div class="order-wrapper-hd">
      <ul class="order-tab">
        <li :class="{ active: tab === 1 }" @click="switchTab(1)">
          可编辑日志订单
        </li>
        <li :class="{ active: tab === 2 }" @click="switchTab(2)">
          不可编辑日志订单
        </li>
      </ul>
    </div>
    <div class="order-wrapper-bd">
      <loadData
        viewName="sevOrderlist"
        :fetchData="serviceOrderList"
        :fetchMethod="getOrderList"
        :controlPage="changePage"
        :page="pageIndex"
        :pageSize="pageSize"
        :firstFetch="firstFetch"
        :hasErr="hasErr"
        :otherParams="{
          errText: '暂无服务中订单需要编写日志',
          errImg: errorImg
        }"
      />
    </div>
  </div>
</template>

<script>
import empty from '@/components/common/empty'
import loadData from '@/components/loadMore'

export default {
  components: {
    loadData
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      firstFetch: true,
      hasErr: false,
      tab: 1,
      serviceOrderList: [],
      errorImg:
        '//cmspic-10004025.image.myqcloud.com/c98bc390-d446-11e9-8bdf-3976ec5da829_size_300x300'
    }
  },
  async created() {
    this.$$title('服务日志')
    await this.getOrderList()
  },
  mounted() {
    this.$$allowRefreshOrShare(true, false)
  },
  methods: {
    ensureLogin() {
      const bid = this.$$cookie('bid')
      const token = this.$$cookie('token')
      const empId = this.$$cookie('empId')
      if (bid && token) {
        return {
          bid,
          token,
          empId
        }
      } else {
        location.href = `${location.host}/login?cmd=login`
      }
    },
    async getOrderList() {
      const { bid, token, empId } = this.ensureLogin()
      const { pageIndex, pageSize } = this
      const qurery = {
        bid,
        token,
        serviceCode: empId,
        orderStates: this.tab === 1 ? '20,30,40' : '10,50',
        pageIndex,
        pageSize
      }
      const list = await this.$store.dispatch('fetchServiceOrderListB', {
        param: JSON.stringify(qurery)
      })
      this.serviceOrderList.push(...(list || []))
      this.$$loading(false)
      this.firstFetch = false
    },
    async switchTab(tab) {
      this.tab = tab
      this.serviceOrderList = []
      await this.getOrderList()
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.order-content {
  min-height: 100%;
  .order-wrapper-hd {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
  .order-wrapper-bd {
    position: absolute;
    left: 0;
    top: rem(80px);
    right: 0;
    bottom: 0;
    background: #f4f4f4;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .order-tab {
    display: flex;
    font-size: rem(28px);
    background-color: #ffffff;
    @include border(bottom);
    li {
      flex: 1;
      height: rem(80px);
      line-height: rem(80px);
      text-align: center;
      &.active {
        color: #ff397e;
        border-bottom: 1px solid #ff397e;
      }
    }
  }
}
</style>
